module.exports = __webpack_public_path__ + "img/product_26.8094b79.webp";